import React, { useEffect, useState } from 'react'
import {Spinner, Stack} from 'react-bootstrap'
import Chart from 'react-apexcharts'

interface Props {
  salesPerformace : any
  reload: any
}

export default function SalesPerformance({salesPerformace, reload}:Props) {
  const [height, setHeight] = useState<any>('');
  const [xTickAmount, setXTickAmount] = useState<number>();


  const saleData = salesPerformace?.salesChannels.map((sales: any) => ({
    x: sales.salesChannelName,
    y: sales.tpvAcceptedCount,
  }))

  useEffect(() => {
    const length = salesPerformace?.salesChannels.length;
    setHeight(length * 6);
    if(length == 1 && salesPerformace?.salesChannels[0].tpvAcceptedCount == 2){
      setXTickAmount(salesPerformace?.salesChannels.length + 1)
    }else{
      setXTickAmount(salesPerformace?.salesChannels.length)
    }
  }, [salesPerformace])

  const series = [
    {
      name: 'Bar',
      data: saleData,
    },
  ]

  const optionsSalesPerformance: Object = {
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: height,
        borderRadius: 7,
        maintainAspectRatio : false,
        indexAxis: 'y',
      },
    },
    colors: [
      '#3E97FF',
      '#3E97FF',
      '#3E97FF',
      '#3E97FF',
      '#3E97FF',
      '#3E97FF',
      '#3E97FF',
      '#3E97FF',
      '#3E97FF',
      '#3E97FF',
      '#3E97FF',
    ],
    grid: {
      strokeDashArray: 3,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
      row: {},
      stroke: {
        colors: ['transparent'],
        width: 15,    
    },
      padding: {
        right: 25,
        left: 15,
      },
    },
    xaxis: {
      tickAmount: xTickAmount,
      labels: {
        trim: true,
        style: {
          fontWeight: 500,
        },
        formatter: function (val: number) {
          return val.toFixed(0);
        }
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tickPlacement: 'between',
      title: {
        style: {
          fontWeight: 700,
        },
      },
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      tickAmount: 5,
      labels: {
        offsetY: -6,
        style: {
          fontSize: 12,
          fontWeight: 500,
        },
      },
      title: {
        style: {
          fontWeight: 700,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    stroke: {
      show: false,
    },
    chart: {
      toolbar: {
        show: false,
      },
      events: {
        updated : (ev:any) => {          
          const cellSize = 30;
          const chart = ev.target;
          const categoryAxis = chart.yAxes.getIndex(0);
          const adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight;
          const targetHeight = chart.pixelHeight + adjustHeight;
    
          // Set it on chart's container
          chart.svgContainer.htmlElement.style.height = targetHeight + "px";
        }
      }
    },
  }
  
  return (
    <div className='card card-flush card-border mb-5 mb-xl-110 h-auto'>
      <Stack gap={2} className='container mt-5 mb-5 ms-4'>
        <div className='text-dark fw-bolder fs-3'>Sales Performance</div>
        <Stack direction='horizontal' gap={2}>
          <div className='fw-bold fs-6 text-dark'>{`${salesPerformace?.tpvAccepted}`}</div>
          <div className='text-muted fs-6'>QC Approved Sales</div>
        </Stack>
      </Stack>
      {reload
        ? (
        <div className="text-center mb-20">
          <Spinner animation="border" className="text-gray-600 text-center" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div
          className='container mb-5 hover-scroll-overlay-y mh-315px'>
            {/* style={{height: '335px', maxHeight: '335px', overflowY: 'auto'}} */}
          <Chart type='bar' series={series} options={optionsSalesPerformance} height={315} />
          {/* height={520} */}
        </div>
      )}
    </div>
  )
}
